import React from 'react';

/** The trimmed search text once typing pauses, so each keystroke does not start a server search. */
export function useDebouncedSearch(value: string, delay = 300) {
  const [search, setSearch] = React.useState(() => value.trim());
  React.useEffect(() => { const timer = window.setTimeout(() => setSearch(value.trim()), delay); return () => window.clearTimeout(timer); }, [value, delay]);
  return search;
}
